import produce from 'immer'

import config from 'config'

const resolveLocalAction = (type) =>
  type.replace(`${config.REDUX_ACTION_NAMESPACE}_`, '')

function createReducer(
  initialState,
  actionsMap,
  shouldResolveLocalAction = false
) {
  return (state = initialState, action) => {
    return produce(state, (draft) => {
      if (!action.type) {
        return draft
      }

      const actionType = shouldResolveLocalAction
        ? resolveLocalAction(action.type)
        : action.type
      const caseReducer = actionsMap[actionType]

      if (caseReducer) {
        return caseReducer({ draft, action })
      }

      return draft
    })
  }
}

export default createReducer
